import Box from '@mui/material/Box'

import type { FilterOption, GroupedFilterOption } from '@models/Filter'

import { DashboardCard } from '../../../aansluiting/dashboard/components/DashboardCard'
import { Grid } from '../../../theme/components/Grid'
import { initialState } from '../../projecten/services/searchProjecten'
import { useKpi } from '../hooks/useKpi'
import type { OnClickTile } from '../types/DashboardNavigation'
import type { Kpi } from '../types/Kpi'

import { ProcesstappenFilters } from './ProcesstappenFilters'

interface Props {
  onClickTile: OnClickTile
  filterOptions: {
    labels: FilterOption[]
    hoofdleiding: {
      gebieden: FilterOption[]
      netbeheerders: string[]
      verantwoordelijken: GroupedFilterOption[]
      typeWerkTypes: string[]
    }
  }
}

export const Processtappen = ({ onClickTile, filterOptions }: Props) => {
  const {
    data: kpis,
    filters,
    initialFilters,
    onChangeFilters,
    onRefresh,
    onReset,
  } = useKpi()

  const onClick = (kpi: Kpi) => {
    const {
      gebied,
      labels,
      netbeheerder,
      myList,
      verantwoordelijke,
      contactpersoon,
    } = filters

    onClickTile({
      url: '/hoofdleiding/projecten',
      query: {
        filters: {
          ...initialState.query.filters,
          gebied,
          labels,
          processtap: [kpi.statusText],
          netbeheerder,
          myList,
          verantwoordelijke,
          contactpersoon,
        },
        page: initialState.query.page,
        sort: initialState.query.sort,
      },
    })
  }

  return (
    <>
      <ProcesstappenFilters
        filters={filters}
        onChange={onChangeFilters}
        initialFilters={initialFilters}
        onRefresh={onRefresh}
        onReset={onReset}
        filterOptions={filterOptions}
      />
      <Box sx={{ p: '50px' }}>
        <Grid sx={{ width: '100%' }} container spacing={2}>
          {kpis
            .filter((kpi) => !kpi.code)
            .map((kpi) => (
              <Grid key={kpi.statusText}>
                <DashboardCard
                  onClick={() => onClick(kpi)}
                  label={kpi.statusText}
                  count={kpi.total}
                />
              </Grid>
            ))}
        </Grid>
      </Box>
    </>
  )
}
